import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/savedProducts';
import { post, get } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* loadReadyProducts({ payload }) {
  try {
    const response = yield call(post, '/operation/ready/load', payload);
    yield put(action.loadReadyProductsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.loadReadyProductsFail());
  }
}

export function* saveReadyProducts({ payload }) {
  try {
    const response = yield call(post, '/operation/ready/save', payload);
    yield put(action.getSavedProducts(response));
    yield put(action.saveReadyProductsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.saveReadyProductsFail());
  }
}

export function* getSavedProducts({ payload }) {
  try {
    const response = yield call(get, `/operation/ready/get/?operationNumId=${payload}`);
    yield put(action.getSavedProductsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getSavedProductsFail());
  }
}

export function* getReadyProductsBySemi({ payload }) {
  try {
    const response = yield call(post, '/grid/production/ready_product/by_semi', payload);
    yield put(action.getReadyProductsBySemiSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getReadyProductsBySemiFail());
  }
}

export function* getZdvlByTask({ payload }) {
  try {
    const response = yield call(get, `/grid/data/zdvl/by_task?taskNumId=${payload.taskNumId}`);
    yield put(action.getZdvlByTaskSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getZdvlByTaskFail());
  }
}
